export const UserStatus = {
    UNINITIALIZED: "uninitialized",
    UNAUTHENTICATED: "unauthenticated",
    DOES_NOT_EXIST: "does_not_exist",
  };